import { useEffect, useState } from "react";
import { type Output } from "valibot";

import { getIpLookup } from "shared/ipLookup";
import { requestBackend } from "shared/request";

import { LocationBasedConsentInfo } from "./schemas";

function useLocationBasedConsentInfo(token: string) {
  const [locationBasedConsentInfo, setConsentIntegrationInfo] =
    useState<Output<typeof LocationBasedConsentInfo>>();

  const [loading, setLoading] = useState<boolean>(true);

  const getConsentIntegrationInfo = async () => {
    try {
      const ipLookup = await getIpLookup({
        isCountryCodeRequired: true,
      });
      const countryCode = ipLookup?.country_code || null;
      const endpoint = `/v1/botsonic/widget/location-based-consent-info${
        countryCode ? `?country_code=${countryCode}` : ""
      }`;

      const res = await requestBackend(endpoint, {
        headers: {
          token,
        },
        schema: LocationBasedConsentInfo,
      });
      setConsentIntegrationInfo(res);
    } catch (err) {
      // eslint-disable-next-line no-console
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getConsentIntegrationInfo();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    locationBasedConsentInfo,
    loading,
  };
}

export default useLocationBasedConsentInfo;
